angular
     .module('vppApp').directive("fieldValueDirective", function() {
    return {
        link: function(scope, elem, attrs, ctrl) {
            attrs.$observe('value', function(nv) {
                console.log('this is a field validator ' +nv);
                if (nv) {
                    console.log(nv);
                    // pass value to app controller
                    scope.fieldAttVal = nv;
                }
            });
        }
    };
});